<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">Upload Data</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Upload Purpose*">
              <b-select
                name="upload_purpose"
                v-model="uploadForm.uploadPurpose"
                expanded
                required
                v-on:input="setUploadPurpose"
                placeholder="Please select"
              >
                <option value="New Upload" selected>New Upload</option>
                <option value="replacement">Document Replacement</option>
              </b-select>
            </b-field>
            <b-field label="Customer Name">
              <b-select
                name="customer"
                v-model="uploadForm.customer"
                expanded
                required
                v-on:input="fetchSpecificDocument"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                  selected
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Country">
              <b-select
                expanded
                name="country"
                v-model="uploadForm.country"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                  selected
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="Period">
              <b-input
                name="period"
                v-model="uploadForm.period"
                maxlength="10"
              />
            </b-field>

            <b-field label="Stream">
              <b-select
                expanded
                name="stream"
                v-model="uploadForm.stream"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in containers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Document to Replace*" v-if="document_replacement">
              <b-select
                expanded
                name="replace_document"
                v-model="uploadForm.docToReplace"
                placeholder="Please select"
                v-if="file.length > 0"
                data-cy="replace_document_with_value"
              >
                <option
                  v-for="(option, index) in file"
                  :value="option.id"
                  :key="index"
                >
                  <span v-if="option.document">
                    {{
                      option.document
                        .substring(option.document.lastIndexOf("/") + 1)
                        .replaceAll("%20", " ")
                    }}
                  </span>
                </option>
              </b-select>
              <b-select
                expanded
                name="replace_document"
                v-model="uploadForm.docToReplace"
                placeholder="Please select"
                data-cy="replace_document_with_out_value"
                v-else
              >
              </b-select>
            </b-field>
            <section>
              <b-field label="Choose a document to attach*"> </b-field>
              <b-field
                required
                class="file is-primary"
                v-if="document_replacement"
              >
                <b-upload
                  required
                  v-model="uploadForm.document"
                  class="file-label"
                  drag-drop
                >
                  <span>
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your file here or click to upload</p>
                      </div>
                    </section>
                  </span>
                </b-upload>
              </b-field>
              <b-field required class="file is-primary" v-else>
                <b-upload
                  required
                  v-model="uploadForm.document"
                  class="file-label"
                  multiple
                  drag-drop
                >
                  <span>
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section>
                  </span>
                </b-upload>
              </b-field>
              <div class="tags" v-if="!document_replacement">
                <span
                  v-for="(file, index) in uploadForm.document"
                  :key="index"
                  class="tag is-primary"
                >
                  {{ file.name }}
                  <button
                    class="delete is-small"
                    type="button"
                    @click="deleteFile(index)"
                  ></button>
                </span>
              </div>
              <div v-else>
                <span v-if="uploadForm.document" class="tag is-primary">
                  {{ uploadForm.document.name }}
                </span>
              </div>
            </section>
            <b-field v-if="document_replacement" label="Comment*">
              <b-input
                type="textarea"
                name="comment"
                v-model="uploadForm.comment"
                required
              />
            </b-field>
            <b-field v-else label="Comment">
              <b-input
                type="textarea"
                name="comment"
                v-model="uploadForm.comment"
              />
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
        >
          Upload
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import ClientCredentialsService from "@/services/ClientCredentialsService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import ContactInformationService from "@/services/ContactInformationService";
import AccountCustomerService from "../../services/AccountCustomerService";
import CustomerUploadService from "../../services/CustomerUploadService";
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import { LoadingProgrammatic as Loading } from "buefy";
// @group Dashboard
export default {
  name: "ClientCredentialsAddView",
  mixins: [UtilityMixin, scopeMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    accountId: {
      type: Number,
      default: -1
    },
    allCustomers: {
      type: Array,
      default() {
        return [];
      }
    },
    allCountries: {
      type: Array,
      default() {
        return [];
      }
    },
    allContainers: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      isModalActive: false,
      customers: this.allCustomers,
      countries: this.allCountries,
      containers: this.allContainers,
      file: [],
      switchCustomerId: null,
      document_replacement: false,
      uploadPurposeList: ["New Upload", "Document Replacement"],
      clientCredentialsService: new ClientCredentialsService(),
      customerDataService: new CustomerProfileDataService(),
      contactInformationService: new ContactInformationService(),
      accountCustomerService: new AccountCustomerService(),
      customerUploadService: new CustomerUploadService(),
      loading: "",
      isFormView: true,
      uploadForm: {
        uploadPurpose: "New Upload",
        customer: "",
        country: "",
        scheme: "",
        stream: "",
        document: null,
        docToReplace: null,
        comment: ""
      }
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
  },
  methods: {
    deleteFile(index) {
      this.uploadForm.document.splice(index, 1);
    },
    setUploadPurpose() {
      if (this.uploadForm.uploadPurpose == "replacement") {
        this.document_replacement = true;
      } else {
        this.document_replacement = false;
      }
      this.uploadForm.document = null;
    },
    fetchCustomerDocument() {
      this.customerUploadService.getAll(this.switchCustomerId).subscribe(
        response => {
          this.file = response;
        },
        e => {
          console.log(e);
        }
      );
    },

    fetchSpecificDocument(customer_id) {
      this.customerUploadService.getAll(customer_id, true).subscribe(
        response => {
          const uploadedDocuments = [];
          response.results.forEach(element => {
            element.document_uploaded.forEach(e => {
              uploadedDocuments.push(e);
            });
          });
          this.file = uploadedDocuments;
        },
        e => {
          console.log(e);
        }
      );
    },
    cancel() {
      this.uploadForm.uploadPurpose = "New Upload";
      this.uploadForm.customer = "";
      this.uploadForm.country = "";
      this.uploadForm.scheme = "";
      this.uploadForm.stream = "";
      this.uploadForm.period = " ";
      this.uploadForm.document = null;
      this.uploadForm.docToReplace = null;
      this.uploadForm.comment = "";
      this.document_replacement = false;
      this.$emit("cancel");
    },

    handleApiError(reason) {
      let errorMessage = "";
      for (const v in reason.response.data) {
        errorMessage += v + ": " + reason.response.data[v] + "<br>";
      }
      this.loading.close();
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    submit() {
      this.loading = Loading.open({
        container: null
      });
      if (this.document_replacement == false) {
        this.customerUploadService
          .create(this.uploadForm)
          .subscribe(response => {
            this.fetchCustomerDocument();
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Upload Successfull!"
            });
            this.loading.close();
            this.$emit("confirm", response);
          }, this.handleApiError);
      } else {
        this.customerUploadService
          .update(this.uploadForm)
          .subscribe(response => {
            this.fetchCustomerDocument();
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Document Replacement Successfull!"
            });
            this.loading.close();
            this.$emit("confirm", response);
          }, this.handleApiError);
      }
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    },
    allCustomers(newVal) {
      this.customers = newVal;
      this.fetchCustomerDocument();
    },
    allCountries(newVal) {
      this.countries = newVal;
    },
    allContainers(newVal) {
      this.containers = newVal;
    }
  }
};
</script>
